import React from 'react';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import Products from '../components/Products';
import { useTranslation } from 'react-i18next';
import { useDocTitle } from '../components/CustomHook';
import { I18nextProvider } from "react-i18next";
import i18n from "../i18n";
import { Helmet } from 'react-helmet';
import { useProjectModal } from '../components/ProjectModal/ProjectModalContext';

const Portefolio = () => {
    useDocTitle('kesnelDigital - Portefolio');
    const { t } = useTranslation();
    const { open } = useProjectModal();

    return (
        <I18nextProvider i18n={i18n}>
            <Helmet>
                <meta name="description" content="Explore Kesnel Digital's portfolio and discover our diverse range of innovative solutions that showcase our expertise in creating digital experiences that exceed expectations. Get inspired by our success stories and the value we bring to each project." />
            </Helmet>
            <NavBar />

            <div className="bg-slatex-50 pt-32 pb-20 lg:pt-40 lg:pb-28">
                <Products />
            </div>

            {/* Closing CTA */}
            <section className="bg-white pb-20 lg:pb-28">
                <div className="container-x">
                    <div className="relative overflow-hidden rounded-3xl cta-surface px-8 py-14 lg:px-16 lg:py-16 text-center" data-aos="fade-up">
                        <h2 className="text-3xl md:text-4xl font-extrabold text-white">{t('product.ctaTitle')}</h2>
                        <p className="mx-auto mt-4 max-w-xl text-lg text-brand-100/90">{t('product.ctaText')}</p>
                        <button type="button" onClick={open} className="btn-primary !bg-white !text-ink hover:!bg-brand-50 mt-8 group !px-8 !py-4 text-base">
                            {t('product.ctaButton')}
                            <svg className="w-5 h-5 transition-transform group-hover:translate-x-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" /></svg>
                        </button>
                    </div>
                </div>
            </section>

            <Footer />
        </I18nextProvider>
    );
}

export default Portefolio;
